/* eslint-disable no-dupe-keys */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../layout/content/Content";
import {
    Spinner,
    Modal,
    ModalBody, ModalFooter
} from "reactstrap";
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
    BlockDes,
    BlockHead,
    PaginationComponent
} from "../../../../components/Component";
import Head from "../../../../layout/head/Head";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import OptionS from "../../../components/DynmicOption/OptionS";
import OptionC from "../../../components/DynmicOption/OptionC";
import OptionM from "../../../components/DynmicOption/OptionM";
import loadspinner from "../../../../assets/images/spinner.gif"
import Swal from "sweetalert2"

const ES8DataReport = ({ ...props }) => {
    const itemPerPage = 500;
    const [currentPage, setCurrentPage] = useState(1);
    const [Statee, setStatee] = useState([]);
    const [id, setid] = useState(0);
    const [loadmain, setloadmain] = useState(true);
    const [load, setload] = useState(false);
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const [modal, setmodal] = useState(false);
    const today = new Date();
    const tableRef = useRef(null);
    const tableRef1 = useRef(null);
    const [generate1, setgenerate1] = useState(true);
    const [nextloading, setnextloading] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        tomonth: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() + 1 : sessionStorage.getItem("CurrentMonth"),
        todummymonth: sessionStorage.getItem("CurrentMonth2") === null ? month1[today.getMonth() + 1] : month1[sessionStorage.getItem("CurrentMonth2")],
        toyear: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 8,
        state: -1
    });
    const [states, setstates] = useState("")
    const [DataCount, setDataCount] = useState(0)
    //console.log(DataCount)
    const paginate = (pageNumber) => {
        setnextloading(true)
        setStatee([])
        var mainid = document.getElementById("datashow");
        mainid.scrollIntoView()
        //console.log("MainId", mainid)
        setCurrentPage(pageNumber)

        if (formData.state !== String(0)) { getdata3(pageNumber) } else { getdataAll(pageNumber) }


    };
    const onInputChange = (e) => {
        var index = e.nativeEvent.target.selectedIndex;
        setstates(e.nativeEvent.target[index].text)
        setFormData({ ...formData, [e.target.name]: e.target.value });

    };
    const onInputChange2 = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    const onInputChange3 = (tomonth, toyear) => {
        setFormData({ ...formData, tomonth: tomonth, toyear: toyear });

    };
    const getdata3 = async (pageno) => {
        const sendData = {

            EmploymentRefId: Number(8),
            UserId: Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth),
            Take: Number(itemPerPage),
            Skip: Number((pageno - 1) * itemPerPage)
        }
         // Validate UserId before sending request
        if (sendData.UserId < 1) {
            console.error('Invalid UserId:', sendData.UserId);
            setStatee([]);
            setload(true);
            setmodal(false);
            setnextloading(false);
            alert("Please select a state.");
            return;
        }

        console.log('Sending request with data:', sendData)
       // console.log("SendData", sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES8MIS', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log("Report_Data", data)
                    setStatee(data)
                    if (data.length === 0) {
                        setmodal(false)

                    }
                    setload(true)
                    setmodal(false)
                    setTimeout(() => {
                        setnextloading(false)
                    }, 1000)

                })


    };

    const getdatacount = async () => {
        const sendData = {

            EmploymentRefId: Number(8),
            UserId: Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/COUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    // console.log("Count", data)
                    setDataCount(data)

                })


    };

    const getdatacountAll = async () => {
        const sendData = {

            EmploymentRefId: Number(8),
            UserId: Number(0),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ALLCOUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log("Count", data)
                    setDataCount(data)

                })


    };

    const getdataAll = async (page) => {

        try {
            const sendData = {
                EmploymentRefId: Number(8),
                UserId: Number(0),
                StateId: Number(formData.state),
                MonthId: Number(formData.month),
                YearId: Number(formData.year),
                ToYearId: Number(formData.toyear),
                ToMonthId: Number(formData.tomonth),
                Take: Number(itemPerPage),
                Skip: Number((page - 1) * itemPerPage)
            }
            //console.log(sendData)
            await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES8MISALL', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(sendData)

            })
                .then(response => response.json())
                .then(
                    data => {
                        // console.log(data)
                        setStatee(data)
                        if (data.length === 0) {
                            setmodal(false)

                        }
                        setload(true)
                        setmodal(false)
                        setnextloading(false)

                    })

        } catch (error) {
            setStatee([]);
            setload(false);
            setnextloading(false);
            setmodal(false);
            Swal.fire({
                icon: "error",
                title: "Something went wrong",
                text: "Please try after sometime...",
                focusConfirm: false,
            }).then(() => {
                window.location.reload()
            })

        }
    };

    const generateAll = async () => {
        sessionStorage.setItem("NumberES8", 0)
        setloadmain(false)
        setmodal(true)
        setload(false)
        getdatacountAll()
        getdataAll(1)
        setgenerate1(false)



    }


    const generate = async () => {
        if (formData.state === -1) {
            alert("Please select a state.");
            return;
        }
        sessionStorage.setItem("NumberES8", 0)
        setloadmain(false)
        getdatacount()
        getdata3(1)
        setgenerate1(false)
        setmodal(true)
    }

    useEffect(() => {


        if (modal) {
            // console.log("Start")
            const iimain = setTimeout(() => {
                setmodal(false)

            }, 500000);

            setid(iimain);

        }
        else {
            //console.log("Closed", id)
            window.clearTimeout(id);
            setid(0);
        }

    }, [modal])

    const TableRow = React.memo(({ details, itemPerPage, currentPage, month1, index }) => {
        return (
            <tr key={index}>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    {(itemPerPage * (currentPage - 1)) + index + 1}
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{details.yearId}</b>
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{month1[details.monthId]}</b>
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{details.state}</b>
                </td>
                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: 'bold' }}>
                    <b>{details.center}</b>
                </td>
                {details.eSdata.map((data, dataIndex) => (

                    <React.Fragment key={dataIndex}>
                        {data.parametersId === 109 ? (
                            <>

                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }}>
                                    {data.totalAllCategoriesM3 === null ? 0 : data.totalAllCategoriesM3}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }}>
                                    {data.totalAllCategoriesF4 === null ? 0 : data.totalAllCategoriesF4}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }}>
                                    {data.totalAllCategoriesT5 === null ? 0 : data.totalAllCategoriesT5}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }}>
                                    {data.scm6 === null ? 0 : data.scm6}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }}>
                                    <label>{data.scf7 === null ? 0 : data.scf7}</label>
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.sct8 === null ? 0 : data.sct8}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.stm9 === null ? 0 : data.stm9}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.stf10 === null ? 0 : data.stf10}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.stt11 === null ? 0 : data.stt11}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.obcm12 === null ? 0 : data.obcm12}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.obcf13 === null ? 0 : data.obcf13}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.obct14 === null ? 0 : data.obct14}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.phm15 === null ? 0 : data.phm15}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.phf16 === null ? 0 : data.phf16}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.pht17 === null ? 0 : data.pht17}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.minorityCommunityM18 === null ? 0 : data.minorityCommunityM18}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.minorityCommunityF19 === null ? 0 : data.minorityCommunityF19}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {data.minorityCommunityT20 === null ? 0 : data.minorityCommunityT20}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.totalAllCategoriesM3t1 === null ? 0 : details.totalAllCategoriesM3t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.totalAllCategoriesF4t1 === null ? 0 : details.totalAllCategoriesF4t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.totalAllCategoriesT5t1 === null ? 0 : details.totalAllCategoriesT5t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.scm6t1 === null ? 0 : details.scm6t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.scf7t1 === null ? 0 : details.scf7t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.sct8t1 === null ? 0 : details.sct8t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.stm9t1 === null ? 0 : details.stm9t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.stf10t1 === null ? 0 : details.stf10t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.stt11t1 === null ? 0 : details.stt11t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.obcm12t1 === null ? 0 : details.obcm12t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.obcf13t1 === null ? 0 : details.obcf13t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.obct14t1 === null ? 0 : details.obct14t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.phm15t1 === null ? 0 : details.phm15t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.phf16t1 === null ? 0 : details.phf16t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.pht17t1 === null ? 0 : details.pht17t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.minorityCommunityM18t1 === null ? 0 : details.minorityCommunityM18t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.minorityCommunityF19t1 === null ? 0 : details.minorityCommunityF19t1}
                                </td>
                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                    {details.minorityCommunityT20t1 === null ? 0 : details.minorityCommunityT20t1}
                                </td>
                            </>) : data.parametersId === 267 ? (
                                <>

                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.totalAllCategoriesM3t2 === null ? 0 : details.totalAllCategoriesM3t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.totalAllCategoriesF4t2 === null ? 0 : details.totalAllCategoriesF4t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.totalAllCategoriesT5t2 === null ? 0 : details.totalAllCategoriesT5t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.scm6t2 === null ? 0 : details.scm6t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.scf7t2 === null ? 0 : details.scf7t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.sct8t2 === null ? 0 : details.sct8t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.stm9t2 === null ? 0 : details.stm9t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.stf10t2 === null ? 0 : details.stf10t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.stt11t2 === null ? 0 : details.stt11t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.obcm12t2 === null ? 0 : details.obcm12t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.obcf13t2 === null ? 0 : details.obcf13t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.obct14t1 === null ? 0 : details.obct14t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.phm15t2 === null ? 0 : details.phm15t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.phf16t2 === null ? 0 : details.phf16t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.pht17t2 === null ? 0 : details.pht17t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.minorityCommunityM18t2 === null ? 0 : details.minorityCommunityM18t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.minorityCommunityF19t2 === null ? 0 : details.minorityCommunityF19t2}
                                        </td>
                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                            {details.minorityCommunityT20t2 === null ? 0 : details.minorityCommunityT20t2}
                                        </td>
                                    </>) : (
                            <>
                             <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }}>
                                {data.totalAllCategoriesM3 === null ? 0 : data.totalAllCategoriesM3}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }}>
                                {data.totalAllCategoriesF4 === null ? 0 : data.totalAllCategoriesF4}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }}>
                                {data.totalAllCategoriesT5 === null ? 0 : data.totalAllCategoriesT5}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }}>
                                {data.scm6 === null ? 0 : data.scm6}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }}>
                                <label>{data.scf7 === null ? 0 : data.scf7}</label>
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.sct8 === null ? 0 : data.sct8}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.stm9 === null ? 0 : data.stm9}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.stf10 === null ? 0 : data.stf10}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.stt11 === null ? 0 : data.stt11}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.obcm12 === null ? 0 : data.obcm12}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.obcf13 === null ? 0 : data.obcf13}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.obct14 === null ? 0 : data.obct14}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.phm15 === null ? 0 : data.phm15}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.phf16 === null ? 0 : data.phf16}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.pht17 === null ? 0 : data.pht17}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.minorityCommunityM18 === null ? 0 : data.minorityCommunityM18}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.minorityCommunityF19 === null ? 0 : data.minorityCommunityF19}
                            </td>
                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }}>
                                {data.minorityCommunityT20 === null ? 0 : data.minorityCommunityT20}
                            </td></>)}
                    </React.Fragment>

                ))}

            </tr>
        );
    });

    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                    <Block>
                        <BlockHead size="lg">

                            <BlockDes className="text-soft">
                                <Row >

                                    <Col xl="2" md="2">
                                        <td >
                                            <h5 style={{ color: '#798bff' }}>DGE Dashboard</h5>
                                        </td>
                                    </Col>
                                    <Col xl="3" md="3" >

                                        <label style={{ color: 'black', fontSize: 15 }}>  State :  <label style={{ fontWeight: 'bold' }}><OptionS catid="43" onInputChange={onInputChange} namemain="state" mainid="state" /></label></label>
                                    </Col>
                                    <Col xl="3" md="3" >

                                        <label style={{ color: 'black', fontSize: 15 }}>  From:<label style={{ fontWeight: 'bold' }}><OptionC onInputChange={onInputChange2} year={formData.year} month={formData.month} /></label></label>
                                    </Col>
                                    <Col xl="3" md="3" >

                                        <label style={{ color: 'black', fontSize: 15 }}> To: <label style={{ fontWeight: 'bold' }}><OptionM onInputChange={onInputChange3} year={formData.year} month={formData.month} /></label></label>
                                    </Col>
                                    <Col xl="3" md="3" >
                                        {formData.state !== String(0) ? (
                                            <Button
                                                color="success"
                                                style={{ marginTop: 10 }}
                                                onClick={() => generate()}
                                            >
                                                Generate
                                            </Button>
                                        ) : (
                                            <Button
                                                color="success"
                                                style={{ marginTop: 10 }}
                                                onClick={() => generateAll()}
                                            >
                                                Generate
                                            </Button>
                                        )}


                                    </Col>
                                </Row>
                            </BlockDes>
                        </BlockHead>
                        <Modal isOpen={false} fullscreen="xl" size="xl" >
                            <ModalBody>

                                <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <img src={loadspinner} alt="load" />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={() => window.location.reload()}>
                                    Stop Report
                                </Button>{' '}

                            </ModalFooter>
                        </Modal>
                        <hr />
                        {generate1 ? <h3>Please Select State and Month to Generate Report!!</h3> :
                            <>
                                {modal ? <div>
                                    <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Spinner size="xl" />
                                    </div>
                                </div> : null}
                                <div style={{ visibility: modal ? "hidden" : "visible" }}>

                                    <Row>
                                        <Col md="2" lg="3">
                                            <h4 style={{ marginBottom: 40 }}>Employment Report (ES8)</h4>
                                        </Col>
                                        <Col md="2" lg="3">

                                        </Col>
                                        {loadmain ?
                                            <Col md="2" lg="3">

                                                <Button disabled style={{ float: "right", marginBottom: 10 }} color="danger" ><Icon className="icon ni ni-download"></Icon>Export Excel Abbreviation</Button>

                                            </Col> : <Col md="2" lg="3">
                                                <DownloadTableExcel
                                                    filename="ES8 Report Abbreviation"
                                                    sheet="users"
                                                    currentTableRef={tableRef1.current}
                                                >
                                                    <Button style={{ float: "right", marginBottom: 10 }} color="warning" ><Icon className="icon ni ni-download"></Icon>Export Excel Abbreviation</Button>
                                                </DownloadTableExcel>
                                            </Col>}

                                        {loadmain ?
                                            <Col md="2" lg="3">

                                                <Button disabled style={{ float: "right" }} color="danger" ><Icon className="icon ni ni-download"></Icon>Export Excel</Button>

                                            </Col> : <Col md="2" lg="3">
                                                <DownloadTableExcel
                                                    filename="ES8 Report"
                                                    sheet="users"
                                                    currentTableRef={tableRef.current}
                                                >
                                                    <Button style={{ float: "right" }} color="info" ><Icon className="icon ni ni-download"></Icon>Export Excel</Button>
                                                </DownloadTableExcel>
                                            </Col>}
                                    </Row>


                                    <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                        <table className="table table-orders" ref={tableRef1} style={{ borderCollapse: "separate", borderSpacing: 0, border: '1px solid black' }}>
                                            <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0 }}>


                                                <tr> <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                    Activity

                                                </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                        Abbreviation

                                                    </th>
                                                    <br />

                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                        Activity

                                                    </th>
                                                    <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                                        Abbreviation

                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >No. who received individual Guidance</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >REC_IN_GU</td>
                                                    <br />
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >Total (All categories)</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >TOT</td>

                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >No. who received registration Guidance</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >REC_REG_GU</td>
                                                    <br />
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >SC</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SC</td>

                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >No. who received individual information</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >REC_IN_IF</td>
                                                    <br />
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >ST</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >ST</td>

                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >No. of old cases reviewed from the Live Register (Only those who responded)</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OC_REV_LR</td>
                                                    <br />
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >OBC</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>

                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >No. of persons participated in Group discussions</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PER_GD</td>
                                                    <br />
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >PWD</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >PWD</td>

                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >No. of applicants placed in</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >APP_P</td>
                                                    <br />
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >Women</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >W</td>

                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >Jobs</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >APP_P_J</td>
                                                    <br />
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "150px" }} >Transgender</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >TR</td>


                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Training</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >APP_P_T</td>

                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Apprenticeship</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >APP_P_A</td>

                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >No. of educational institution visited for promoting Guidance activities (Activities other than those listed above)</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >EDU_GU_ACT</td>

                                                </tr>
                                                <tr>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >No. of Establishments/ Institutions visited for development for Jobs, training of apprenticeship opportunities for collection of information pertaining of such opportunities</td>
                                                    <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >EST_DEJ_TOA</td>

                                                </tr>



                                            </thead>

                                        </table>

                                    </div>


                                    <div className="card-inner-group" style={{ border: '4px solid black', padding: 2 }}>

                                        <div style={{ height: window.innerHeight - 100, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                            <span id="datashow" style={{ visibility: "hidden", height: 0, width: 0 }}></span>
                                            <table className="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                                        <tr>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                Form: ES8 Report

                                                            </th>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                State: {states}

                                                            </th>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                From Date: {month1[formData.month]} {formData.year}

                                                            </th>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                To Date: {month1[formData.tomonth]} {formData.toyear}

                                                            </th>
                                                        </tr>
                                                    </thead>
                                                </div>

                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                    <tr>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            S. No.

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            Year

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            Month

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            State
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            Employment Exchange

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_T_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_T_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_T_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_SC_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_SC_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_SC_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_ST_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_ST_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_ST_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_OBC_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_OBC_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_OBC_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_PWD_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_PWD_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_PWD_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_MIN_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_MIN_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_APP_SE_HF_MIN_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_T_M
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_T_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_T_TR
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_SC_M
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_SC_F
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_SC_TR
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_ST_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_ST_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_ST_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_OBC_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_OBC_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_OBC_TR
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_PWD_M
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_PWD_F
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_PWD_TR
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_MIN_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_MIN_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_REF_SE_ASST_HF_MIN_TR
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_T_M
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_T_F
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_T_TR
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_SC_M
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_SC_F
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_SC_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_ST_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_ST_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_ST_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_OBC_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_OBC_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_OBC_TR
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_PWD_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_PWD_F
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_PWD_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_MIN_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_MIN_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_CAD_SET_SE_MIN_TR
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_T_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_T_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_T_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_SC_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_SC_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_SC_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_ST_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_ST_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_ST_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_OBC_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_OBC_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_OBC_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_PWD_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_PWD_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_PWD_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_MIN_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_MIN_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            R_TOT_MIN_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_T_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_T_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_T_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_SC_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_SC_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_SC_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_ST_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_ST_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_ST_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_OBC_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_OBC_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_OBC_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_PWD_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_PWD_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_PWD_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_MIN_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_MIN_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_APP_SE_HF_MIN_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_T_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_T_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_T_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_SC_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_SC_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_SC_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_ST_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_ST_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_ST_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_OBC_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_OBC_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_OBC_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_PWD_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_PWD_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_PWD_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_MIN_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_MIN_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_REF_SE_ASST_HF_MIN_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_T_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_T_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_T_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_SC_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_SC_F

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_SC_TR

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_ST_M

                                                        </th>

                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_ST_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_ST_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_OBC_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_OBC_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_OBC_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_PWD_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_PWD_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_PWD_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_MIN_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_MIN_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_CAD_SET_SE_MIN_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_T_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_T_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_T_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_SC_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_SC_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_SC_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_ST_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_ST_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_ST_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_OBC_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_OBC_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_OBC_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_PWD_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_PWD_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_PWD_TR

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_MIN_M

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_MIN_F

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            U_TOT_MIN_TR

                                                        </th>



                                                    </tr>

                                                </thead>

                                                <tbody>

                                                    {nextloading ? (
                                                        <tr>
                                                            <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                                                <div>
                                                                    <h3>Please wait while the report is loading...</h3>
                                                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                        <Spinner size="xl" />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : load ? (
                                                        Statee.length !== 0 && nextloading === false ? (
                                                            Statee.map((details, index) => (
                                                                <TableRow
                                                                    key={index}
                                                                    details={details}
                                                                    itemPerPage={itemPerPage}
                                                                    currentPage={currentPage}
                                                                    month1={month1}
                                                                    index={index}
                                                                />
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="8" style={{ textAlign: 'center' }}>
                                                                    <h3>No Data Found</h3>
                                                                </td>
                                                            </tr>
                                                        )
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8" style={{ textAlign: 'center' }}>
                                                                <Spinner color="success" />
                                                            </td>
                                                        </tr>
                                                    )}


                                                </tbody>
                                            </table>

                                        </div>
                                    </div>
                                </div>
                                {Statee.length > 0 && (
                                    <PaginationComponent
                                        noDown
                                        itemPerPage={itemPerPage}
                                        totalItems={DataCount}
                                        paginate={paginate}
                                        currentPage={currentPage}
                                        EmploymentRefId={5}
                                        UserId={formData.state}
                                        MonthId={formData.month}
                                        YearId={formData.year}
                                        ToYearId={formData.toyear}
                                        ToMonthId={formData.tomonth}
                                        setStatee={setStatee}
                                        setmodal={setmodal}
                                        setload={setload}
                                    />
                                )}
                            </>}
                        <Modal isOpen={false} fullscreen="xl" size="xl" >
                            <ModalBody>

                                <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <img src={loadspinner} alt="load" />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={() => window.location.reload()}>
                                    Stop Report
                                </Button>{' '}

                            </ModalFooter>
                        </Modal>



                    </Block>

            </Content>

        </React.Fragment>
    );
};

export default ES8DataReport;
